export default "__VITE_ASSET__ChPNge_a__"